<template>
  <span class="print-view">
    <div class="btn-group text-center my-4"  v-if="!is_full_screen">
        <vs-button class="mx-1 my-1" type="filled" @click="onClickPrint">Print & Download</vs-button>
    </div>
    <page id="printDiv" size="A4">
       <div class="vx-row mb-0">
            <div class="vx-col w-full">

          <main class="clearfix">

            <div id="user" class="clearfix">

              <div id="user-top">

                <table bgcolor="#fff" border="0" cellspacing="0" cellpadding="0">

                  <tbody>
                  <tr>
                    <td class="head">
                      <img id="logo"
                           src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/ITS-Logo.png"
                           alt="Logo" width="150" height="75"/>
                    </td>
                    <td class="head">
                      <h4 style="color: #000000"><b>Purchase Order</b></h4>
                    </td>
                    <td class="head">
                    <div>
                       <p><b>VAT Reg No:</b> {{ order_details.vat_number }}</p>
                      <p><b>Company No:</b> {{ order_details.company_number}}</p>
                    </div>
                  </td>
                  </tr>
                  <tr>
                  <td colspan="3">
                    <table id="in-tbl">
                      <tr>
                        <td>
                          <div>
                            <p class="sml"><b>Supplier:</b></p>
                            <p v-if="order_details.supplier_name !== ''" class="sml">{{order_details.supplier_name }}</p>
                            <p v-if="order_details.supplier_address.line1 !== 'N/A'" class="sml">{{order_details.supplier_address.line1}}</p>
                            <p v-if="order_details.supplier_address.line2 !== 'N/A'" class="sml">{{order_details.supplier_address.line2}}</p>
                            <p v-if="order_details.supplier_address.line3 !== 'N/A'" class="sml">{{order_details.supplier_address.line3}}</p>
                            <p v-if="order_details.supplier_address.town_state !== 'N/A'" class="sml">{{order_details.supplier_address.town_state}}</p>
                            <p v-if="order_details.supplier_address.post_code !== 'N/A'" class="sml">{{order_details.supplier_address.post_code}}</p>
                            <p v-if="order_details.supplier_address.country !== 'N/A'" class="sml">{{order_details.supplier_address.country}}</p>
                          </div>
                        </td>
                        <td>
                          <div>
                            <p class="sml"><b>Deliver To:</b></p>
                            <p class="sml">{{order_details.deliver_to.name	}}</p>
                            <p class="sml">{{order_details.deliver_to.line1}}</p>
                            <p class="sml">{{order_details.deliver_to.line2}}</p>
                            <p class="sml">{{order_details.deliver_to.line3}}</p>
                            <p class="sml">{{order_details.deliver_to.town_state}}</p>
                            <p class="sml">{{order_details.deliver_to.post_code}}</p>
                            <p class="sml">{{order_details.deliver_to.country}}</p>
                          </div>
                        </td>
                        <td>
                          <div>
                            <p class="sml"><b>Invoice To:</b></p>
                            <p class="sml">{{order_details.invoice_to.name	}}</p>
                            <p class="sml">{{order_details.invoice_to.line1}}</p>
                            <p class="sml">{{order_details.invoice_to.line2}}</p>
                            <p class="sml">{{order_details.invoice_to.line3}}</p>
                            <p class="sml">{{order_details.invoice_to.town_state}}</p>
                            <p class="sml">{{order_details.invoice_to.post_code}}</p>
                            <p class="sml">{{order_details.invoice_to.country}}</p>
                          </div>
                        </td>

                      </tr>

                    </table>
                  </td>
                </tr>
                  </tbody>
                </table>
                <table bgcolor="#fff" border="0" cellspacing="0" cellpadding="0">

                <tbody>


                <tr>
                  <td colspan="3">
                    <table class="txt-center" id="in-tbl">
                      <tr>
                        <td>
                          <div>
                            <p class="sml"><b>Order Date</b></p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p class="sml"><b>Required By Date</b></p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p class="sml"><b>Order Number</b></p>

                          </div>
                        </td>


                      </tr>
                      <tr>
                        <td>
                          <div>
                            <p class="sml">{{ __dateTimeFormatterToDate(order_details.order_date) }}</p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p class="sml">{{order_details.required_by}}</p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p class="sml">{{order_details.order_number}}</p>

                          </div>
                        </td>

                      </tr>

                    </table>
                  </td>
                </tr>





                </tbody>
              </table>
                <table bgcolor="#fff" border="0" cellspacing="0" cellpadding="0">

                <tbody>


                <tr>
                  <td colspan="3">
                    <table class="txt-center" id="in-tbl">
                      <tr>
                        <td>
                          <div>
                            <p><b>Delivery Date</b></p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p><b>Supplier Item Number</b></p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p><b>ITS Product Code</b></p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p><b>Product Name</b></p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p><b>Quantity (kg/l/unit)</b></p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p><b>Unit Price ({{order_details.supplier_account_currency}})</b></p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p><b>Vat ({{order_details.supplier_account_currency}})</b></p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p><b>Value ({{order_details.supplier_account_currency}})</b></p>

                          </div>
                        </td>



                      </tr>

                      <tr v-for="(item, index) in order_details.items" :key="index">
                        <td>
                          <div>
                            <p>{{item.delivery_date}}</p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p>{{item.supplier_item_number}}</p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p>{{item.product_code}}</p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p>{{item.supplier_product_name}}</p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p>{{item.quantity}}</p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p>{{Number(item.price).toFixed(2)}}</p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p>{{Number(item.vat).toFixed(2)}}</p>

                          </div>
                        </td>
                        <td>
                          <div>
                            <p>{{Number(item.value + item.vat).toFixed(2)}}</p>
                          </div>
                        </td>


                      </tr>
                      <tr>
                        <td class="no-bd" colspan="5">
                          &nbsp;</td>
                        <td colspan="3">
                          <table class="no-bd-tbl">
                            <tr>
                              <td class="align-left">
                                <p><b>Net Order Value ({{order_details.supplier_account_currency}})</b></p>
                              </td>
                              <td class="align-right text-black">{{totalCalculator()}}</td>
                            </tr>
                          </table>

                        </td>

                      </tr>

                    </table>
                  </td>
                </tr>

                </tbody>
              </table>
              <!-- Additional Cost Table -->
              <table
                  v-if="order_details.additional_cost && order_details.additional_cost.length"
                  class="txt-center"
                  id="in-tbl"
                >
                  <tr>
                    <td colspan="2">
                      <div>
                        <p class="sml"><b>Additional Costs</b></p>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td width="70%">
                      <div>
                        <p class="sml"><b>Description</b></p>
                      </div>
                    </td>
                    <td width="30%">
                      <div>
                        <p class="sml">
                          <b>Amount ({{ order_details.supplier_account_currency }})</b>
                        </p>
                      </div>
                    </td>
                  </tr>

                  <tr v-for="(cost, index) in order_details.additional_cost" :key="'ac-' + index">
                    <td class="align-left">
                      <p>{{ cost.name }}</p>
                    </td>
                    <td class="align-right">
                      <p>{{ Number(cost.amount).toFixed(2) }}</p>
                    </td>
                  </tr>

                  <tr>
                    <td class="align-right">
                      <p><b>Total Additional Cost</b></p>
                    </td>
                    <td class="align-right">
                      <p>{{ additionalCostTotal() }}</p>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </main>
          <footer>
          <p><b>Special Instruction:</b></p>
          <p>{{order_details.delivery_instruction}}</p>
          <small class="text-black">Generated on {{ __dateTimeFormatter(Date.now()) }}</small>
        </footer>
            </div>
       </div>
    </page>
  </span>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
const SundrySupplierRepository = RepositoryFactory.get('sundry')

function initialState() {
  return {
    open: false,
    is_full_screen: false,
    id: '',
    secret_code: '',
    data: {},
    order_details: {
      supplier_address: {
        name: '',
        line1: '',
        line2: '',
        line3: '',
        town_state: '',
        post_code: '',
        country: ''
      },
      deliver_to: {
        name: '',
        line1: '',
        line2: '',
        line3: '',
        town_state: '',
        post_code: '',
        country: ''
      },
      invoice_to: {
        name: '',
        line1: '',
        line2: '',
        line3: '',
        town_state: '',
        post_code: '',
        country: ''
      },
      order_date: '',
      order_number: '',
      items: [],
      delivery_instruction: '',
      company_number: '',
      vat_number: '',
      additional_cost: [],
      supplier_name: ''
    },
    vat_no: '',
    company_no: ''
  }
}

export default {
  name: "SundryOrderConfirmation",
  data () {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  async mounted() {
    this.secret_code = this.$route.params.key
    this.is_full_screen = this.$route.query.is_full_screen === null
    await this.getInvoiceDetails()
  },
  methods:{
    async getInvoiceDetails() {
      await this.$vs.loading()
      try {
        const {data} = (await SundrySupplierRepository.getSundryOrderPdfPublic(this.secret_code)).data
        this.order_details =  data
      } catch (e) {
        this.showWarningMessage('Something went wrong. Please try again!')
      }
      this.$vs.loading.close()
    },
    onClickPrint() {
      window.print()
    },
    totalCalculator() {
      let total = 0;
      this.order_details.items.forEach((m) => {
        if (!!m.price) {
          total = total + Number(m.value) +  Number(m.vat)
        }
      })
      return total.toFixed(2)
    },
    additionalCostTotal() {
      let total = 0
      if (this.order_details.additional_cost) {
        this.order_details.additional_cost.forEach(c => {
          total += Number(c.amount || 0)
        })
      }
      return total.toFixed(2)
    }
  }

}
</script>

<style lang="scss">

page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

@media print {
  .print-view {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    #printDiv,
    #printDiv * {
      visibility: visible;
    }

    #printDiv {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}


html,
body {
  -webkit-print-color-adjust: exact !important;
}

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

a {
  color: #0087C3;
  text-decoration: none;
}

body {
  position: relative;
  margin: 0 auto;
  color: #000000 !important;
  background: #FFFFFF;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
}

div#full-wrap {
  width: 40cm;
  max-width: 100%;
  margin: 0 auto;
}

h4 {
  font-size: 24px;
}

p {
  font-size: 16px;
  margin: 0;
  color: #000000 !important;
}

.sml {
  font-size: 14px;
}

main {
  padding: 0px 10px 20px 10px;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 20px;
  font-size: 13px;

}

table th,
table td {
  padding: 20px;
  text-align: center;
  vertical-align: top;
}

table th {
  white-space: nowrap;
  font-weight: normal;
  color: #000;
}

table td {
  text-align: left;
}

table.txt-center td {
  text-align: center;
}

table.txt-left td {
  text-align: left;
}

table.txt-right td {
  text-align: right;
}


div#user-top {
  width: 100%;
  margin: 5em auto 2em auto;
}

div#user-top table {
  margin: 0 auto .8em auto;
  text-align: center;
  width: 100%;
}

div#user-top table td {
  padding: 5px 8px;
  font-size: 18px;
}

div#user-top .head {
  vertical-align: middle;
  text-align: center;

}

table#in-tbl {
  width: 100%;

}

table#in-tbl td {
  border: 2px solid #000;

}

td.no-bd {
  border-left: 0px !important;
  border-bottom: 0px !important;
}

table.no-bd-tbl td {
  border: 0px !important;
  padding: 0 !important;
}

table.no-bd-tbl {
  margin-bottom: 0 !important;
}

.align-left {
  text-align: left !important;
}

.align-right {
  text-align: right !important;
}

footer {
  padding: 0 30px;
}

</style>
